import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './futuristic.css';
import './futuristic-cart.css';
import './tesla-robots.css';
import './skill-search.css';
import './employees-page.css';
import './category-industry.css';
import './browse-page.css';
import './about-page.css';
import './api-page.css';
import './auth.css';
import './contact-page.css';
import './demo-page.css';
import './pricing-page.css';
import './how-it-works-page.css';
import './dropdown-menu.css';
import './cart-page.css';
import './faq-page.css';
import './collaboration-page.css';
import './chat-list-page.css';
import './build-employee.css';
import Header from './components/Header';
import NewHomePage from './pages/NewHomePage';
import EmployeesPage from './pages/EmployeesPage';
import ChatPage from './pages/ChatPage';
import CartPage from './pages/CartPage';
import SearchPage from './pages/SearchPage';
import BrowsePage from './pages/BrowsePage';
import AboutPage from './pages/AboutPage';
import ApiPage from './pages/ApiPage';
import AuthPage from './pages/AuthPage';
import DemoPage from './pages/DemoPage';
import ContactPage from './pages/ContactPage';
import PricingPage from './pages/PricingPage';
import HowItWorksPage from './pages/HowItWorksPage';
import FAQPage from './pages/FAQPage';
import CollaborationPage from './pages/CollaborationPage';
import ChatListPage from './pages/ChatListPage';
import BuildEmployeePage from './pages/BuildEmployeePage';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import BackgroundContainer from './components/BackgroundContainer';
import ClarityPageTracker from './components/ClarityPageTracker';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <BackgroundContainer>
            <div className="App">
              <ClarityPageTracker />
              <Header />
            <main className="container">
              <Routes>
                <Route path="/" element={<NewHomePage />} />
                <Route path="/employees" element={<EmployeesPage />} />
                <Route path="/chat" element={<ChatListPage />} />
                <Route path="/chat/:id" element={<ChatPage />} />
                <Route path="/cart" element={
                  <ProtectedRoute>
                    <CartPage />
                  </ProtectedRoute>
                } />
                <Route path="/search" element={<SearchPage />} />
                <Route path="/browse" element={<BrowsePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/api" element={<ApiPage />} />
                <Route path="/login" element={<AuthPage />} />
                <Route path="/register" element={<AuthPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/demo" element={<DemoPage />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/how-it-works" element={<HowItWorksPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/collaboration" element={<CollaborationPage />} />
                <Route path="/build-employee" element={<BuildEmployeePage />} />
              </Routes>
            </main>
            </div>
          </BackgroundContainer>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
